export const correctLink = (href: string): string =>
  /^(http|https)/g.test(href) ? href : `//${href}`;
